import Model from './BaseModel';
import Competition from './Competition';

export default class Sport extends Model {
	resourceName() {
		return 'sports';
	}

	fields() {
		return ['name', 'featured', 'featured_order', 'is_manual', 'icon', 'active', 'cashout_enabled'];
	}

	relationships() {
		return {
			competitions: new Competition()
		};
	}
}
